const initState = {
  status: null,
  currentId: null,
  current: null,
  section: null,
  view: null,
  error: null,
};
const userStatus = (state = initState, action) => {
  switch (action.type) {
    case 'USERS_VIEW':
      console.log(`USERS_VIEW ${action.view} ${action.status}`);
      return {
        ...state,
        view: action.view,
        status: action.status,
      };
    case 'USER_STATUS':
      console.log(`USER_STATUS ${action.status}`);
      return {
        ...state,
        status: action.status,
      };
    case 'SET_USER':
      console.log(`SET_USER ${action.currentId}`);
      return {
        ...state,
        status: action.status,
        currentId: action.currentId,
      };
    case 'NEW_USER_SUCCESS':
      console.log(`NEW_USER_SUCCESS ${action.status}`);
      return {
        ...state,
        currentId: action.currentId,
        status: action.status,
      };
    case 'USER_EMAIL_SENT':
      console.log(`USER_EMAIL_SENT ${action.status}`);
      return {
        ...state,
        status: action.status,
      };

    case 'UPDATE_USER_SUCCESS':
      console.log(`UPDATE_USER_SUCCESS ${action.status}`);
      return {
        ...state,
        currentId: action.currentId,
        status: action.status,
      };
    case 'USER_ERROR':
      console.log(`USER_ERROR ${action.err.message}`);
      return {
        ...state,
        status: 'error',
        error: action.err.message,
      };

    default:
      return state;
  }
};

export default userStatus;
